import { useEffect, useMemo } from 'react'
import { useAppSelector, useAppDispatch } from 'hooks/reduxHooks'

import { fetchAirlines } from 'actions/FlightActions'

export function useAirline(code: string = ''): [App.Airline | undefined, boolean] {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!code) {
      return
    }

    dispatch(fetchAirlines(code))
  }, [code, dispatch])

  const airline = useAppSelector((state) => state.flights.airlines[code])
  return [airline?.data, Boolean(airline?.fetching)]
}

export function useAirlines(codes: Array<string>): [Array<App.Airline>, boolean] {
  const dispatch = useAppDispatch()

  useEffect(() => {
    codes.forEach((code) => {
      dispatch(fetchAirlines(code))
    })
  }, [codes, dispatch])

  const allAirlines = useAppSelector((state) => state.flights.airlines)

  const airlines = useMemo(() => {
    return codes.map(code => allAirlines[code]?.data).filter((a) => !!a)
  }, [allAirlines, codes])

  const isFetching = useMemo(() => {
    return codes.some((code) => allAirlines[code]?.fetching)
  }, [allAirlines, codes])

  return [airlines, isFetching]
}
